<script>
  import { onMount } from "svelte";
  import { announce } from "./Logging.svelte";
  onMount(() => {
    announce("Loading Mounted");
  });
</script>

<div class="loading" role="status" aria-live="polite">
  <img class="loading__logo" src="/images/PC-website-hd-logo.png" alt="PassCall" width="299" height="108" />
  <p class="loading__text">Opening<span class="loading__dots" aria-hidden="true"><i>.</i><i>.</i><i>.</i></span></p>
</div>

<style>
  .loading { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1.5rem; font-family: var(--font); color: var(--on-dark);
    background: radial-gradient(70% 55% at 10% 0%, rgba(31, 107, 63, .58), transparent 65%), radial-gradient(45% 45% at 92% 70%, rgba(212, 175, 55, .2), transparent 65%), var(--ink); }
  .loading__logo { height: 48px; width: auto; filter: brightness(0) invert(1); }
  .loading__text { margin: 0; font-family: var(--display); font-size: 1.4rem; color: var(--on-dark-muted); }
  .loading__dots i { font-style: normal; animation: blink 1.2s infinite; }
  .loading__dots i:nth-child(2) { animation-delay: .2s; }
  .loading__dots i:nth-child(3) { animation-delay: .4s; }
  @keyframes blink { 0%, 60%, 100% { opacity: .2; } 30% { opacity: 1; } }
</style>
